export default __webpack_public_path__ + "media/Dr.SubhashChandra.2868a23b.png";